import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import {
  Flex,
  Button,
  useToast,
  Switch,
  FormLabel,
  FormControl,
  Text,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import { useAuth } from '../../../../auth-context/auth.context';
import SavingsPlanApi from 'api/savingplan';
import SavingPlanVariantApi from 'api/savingplanvariant';
import InputField from 'components/formComponents/inputField';
import SelectField from 'components/formComponents/selectField';
import TextAreaField from 'components/formComponents/textAreaField';
import { SavingPlanVariantValidationSchema } from 'formValidations/savingPlanVariantFormValidations';
import { useHistory } from 'react-router-dom';

const AddNewSavingPlanVariantForm = (props) => {
  const history = useHistory();
  const { user } = useAuth();
  const toast = useToast();
  const toastIdRef = React.useRef();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const [loading, setLoading] = useState(false);
  const [savingPlanList, setSavingPlanLIst] = useState([]);

  const initialValues = {
    savingsPlanId: '',
    minInvestment: '',
    maxInvestment: '',
    period: '',
    multipleInvestment: '',
    benefit: '',
    prematureAllowed: false,
    isAvailable: false,
    status: 'ACTIVE',
  };

  const FetchSavingsplanList = async () => {
    try {
      setLoading(true);
      let response = await SavingsPlanApi.List({
        sort: 'name:asc',
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200 && response?.data?.list?.length > 0) {
        setSavingPlanLIst(response?.data?.list);
        console.log('saving plan array', response?.data?.list);
      } else {
        setSavingPlanLIst([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchSavingsplanList();
  }, []);

  const handleSubmit = async (values, { setSubmitting }) => {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }
    try {
      let response = await SavingPlanVariantApi.Create(values);
      response = response.data;
      if (response.status_code === 200) {
        toastIdRef.current = toast({
          title: response.message || 'Successfully Added',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        history.push('/admin/savingsplanvariant');
      } else {
        toastIdRef.current = toast({
          title: response.message || 'Error Adding',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      toastIdRef.current = toast({
        title: 'Unable to Add',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
      console.log(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Flex direction='column' mt={20} mx={5} maxWidth={'5xl'}>
      <Flex
        alignItems='center'
        justifyContent='space-between'
        mt={10}
        mb={10}
      ></Flex>

      <Formik
        initialValues={initialValues}
        validationSchema={SavingPlanVariantValidationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, setFieldValue }) => (
          <Form noValidate>
            <Flex direction='column'>
              <SelectField
                label='Select Savings Plan'
                required={true}
                name='savingsPlanId'
                placeholder='Select Savings Plan'
                options={savingPlanList?.map((savingPlan) => ({
                  value: savingPlan.id,
                  label: savingPlan.name,
                }))}
              />
              <Card bgColor='gray.200' mt={8}>
                <Flex
                  direction={{ base: 'column', md: 'row' }}
                  justifyContent='space-evenly'
                  gap={2}
                >
                  <InputField
                    label='Minimum Investment'
                    name='minInvestment'
                    required={true}
                    type='number'
                  />
                  <InputField
                    label='Maximum Investment'
                    name='maxInvestment'
                    required={true}
                    type='number'
                  />
                </Flex>

                <Flex
                  direction={{ base: 'column', md: 'row' }}
                  justifyContent='space-evenly'
                  gap={2}
                >
                  <InputField
                    label='Period (in Months)'
                    name='period'
                    required={true}
                    type='number'
                    placeholder='Enter in Months'
                  />
                  <InputField
                    label='Multiple Investment'
                    name='multipleInvestment'
                    required={true}
                    type='number'
                  />
                </Flex>
              </Card>

              {/* <TextAreaField
                variant='auth'
                label='Benefits'
                name='benefit'
                required={true}
                type='text'
                placeholder='Up to 200 Characters'
              /> */}

              <Flex
                direction={{ base: 'column', md: 'row' }}
                justifyContent='space-between'
                mt={4}
                gap={2}
              >
                {/* <FormControl mr={2} mt={14} display='flex' align='center'>
                  <FormLabel>
                    <Text fontSize='md' fontWeight='50'>
                      Premature Withdrawal Allowed
                    </Text>
                  </FormLabel>
                  <Switch
                    mt={1}
                    id='prematureAllowed'
                    onChange={(e) =>
                      setFieldValue('prematureAllowed', e.target.checked)
                    }
                  />
                </FormControl> */}

                <FormControl mr={2} mt={14} display='flex' align='center'>
                  <FormLabel>
                    <Text fontSize='md' fontWeight='50'>
                      Available ?
                    </Text>
                  </FormLabel>
                  <Switch
                    mt={1}
                    id='isAvailable'
                    onChange={(e) =>
                      setFieldValue('isAvailable', e.target.checked)
                    }
                  />
                </FormControl>

                {/* <SelectField
                  label='Status'
                  name='status'
                  options={[
                    { value: 'ACTIVE', label: 'Active' },
                    { value: 'INACTIVE', label: 'Inactive' },
                  ]}
                /> */}
              </Flex>

              <FormControl mt={20}>
                <Button
                  colorScheme='blue'
                  type='submit'
                  isLoading={isSubmitting}
                >
                  Add New Variant
                </Button>
              </FormControl>
            </Flex>
          </Form>
        )}
      </Formik>
    </Flex>
  );
};

export default AddNewSavingPlanVariantForm;
